import { apiClient } from './base';

const NAMESPACE = 'callcenterPerformance';

export const getCallcenterPerformanceSettings = async () => {
  try {
    const response = await apiClient.get(`/business-settings/${NAMESPACE}`);
    return response.data.settings || {};
  } catch (error) {
    throw error;
  }
};

export const saveCallcenterPerformanceSettings = async (settings) => {
  try {
    const response = await apiClient.put(`/business-settings/${NAMESPACE}`, { settings });
    return response.data.settings;
  } catch (error) {
    throw error;
  }
};
